import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";

const CollectionDialog = ({
  open,
  onClose,
  onSave,
  form,
  setForm,
  masters,
  categories,
  items,
  isEditing,
}) => {
  const validate = () => {
    if (!form.name.trim()) return "Name is required";
    if (!form.price || form.price <= 0) return "Valid price is required";
    return null;
  };

  const handleSubmit = () => {
    const error = validate();
    if (error) return alert(error);
    onSave();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{isEditing ? "Edit" : "Add"} Collection</DialogTitle>
      <DialogContent>
        <TextField
          label="Name"
          value={form.name}
          onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          label="Description"
          value={form.description}
          onChange={(e) =>
            setForm((f) => ({ ...f, description: e.target.value }))
          }
          fullWidth
          margin="normal"
        />
        <TextField
          label="Price"
          type="number"
          value={form.price}
          onChange={(e) => setForm((f) => ({ ...f, price: e.target.value }))}
          fullWidth
          margin="normal"
          required
        />
        <Typography variant="subtitle2" sx={{ mt: 1, mb: 1 }}>
          Cost Type
        </Typography>
        <ToggleButtonGroup
          value={form.costMode}
          exclusive
          onChange={(e, value) => {
            if (value) {
              setForm((f) => ({ ...f, costMode: value }));
            }
          }}
          size="small"
          color="primary"
        >
          <ToggleButton value="costPrice">Cost Amount</ToggleButton>
          <ToggleButton value="commissionPercent">Commission %</ToggleButton>
        </ToggleButtonGroup>

        {form.costMode === "costPrice" && (
          <TextField
            label="Cost Amount"
            type="number"
            value={form.costPrice}
            onChange={(e) =>
              setForm((f) => ({ ...f, costPrice: e.target.value }))
            }
            fullWidth
            sx={{ mt: 2 }}
          />
        )}

        {form.costMode === "commissionPercent" && (
          <TextField
            label="Commission %"
            type="number"
            value={form.commissionPercent}
            onChange={(e) =>
              setForm((f) => ({ ...f, commissionPercent: e.target.value }))
            }
            fullWidth
            sx={{ mt: 2 }}
          />
        )}
        <FormControl fullWidth margin="normal">
          <InputLabel>Items</InputLabel>
          <Select
            multiple
            value={form.items}
            onChange={(e) => setForm((f) => ({ ...f, items: e.target.value }))}
            renderValue={(selected) =>
              selected
                .map((id) => items.find((i) => i._id === id)?.name || "")
                .join(", ")
            }
          >
            {items.map((i) => (
              <MenuItem key={i._id} value={i._id}>
                {i.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth margin="normal">
          <InputLabel>Category</InputLabel>
          <Select
            multiple
            value={form.category}
            onChange={(e) =>
              setForm((f) => ({ ...f, category: e.target.value }))
            }
            renderValue={(selected) => selected.join(", ")}
          >
            {categories.map((cat) => (
              <MenuItem key={cat} value={cat}>
                {cat}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {["grades", "programs", "subjects"].map((field) => (
          <FormControl fullWidth margin="normal" key={field}>
            <InputLabel>
              {field.charAt(0).toUpperCase() + field.slice(1)}
            </InputLabel>
            <Select
              multiple
              value={form[field]}
              onChange={(e) =>
                setForm((f) => ({ ...f, [field]: e.target.value }))
              }
              renderValue={(selected) => selected.join(", ")}
            >
              {masters[field].map((opt) => (
                <MenuItem key={opt} value={opt}>
                  {opt}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit}>
          {isEditing ? "Update" : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CollectionDialog;
